module.exports = __webpack_public_path__ + "img/g4.ac9cd885.jpg";